import { ScopeWorkflow } from "../types/types"
import { genericRequest, scopeWorkflowRoute } from "./service"

/**
 * Creates a scope workflow in the cloud database.
 * 
 * @param workflow to upload.
 * @returns created scope workfow object in database.
 */
export const addScopeWorkflow = async (workflow: ScopeWorkflow): Promise<ScopeWorkflow | Error> => {
  return await genericRequest({ url: `${scopeWorkflowRoute}/`, method: "POST", body: JSON.stringify(workflow) })
}

/**
 * Gets all scoped workflows.
 * 
 * @param limit max number of workflows to fetch
 * 
 * @param offset offset of workflows to fetch
 * 
 * @returns scoped workflows
 */
export const getScopeWorkflows = async (limit?: number, offset?: number): Promise<ScopeWorkflow[] | Error> => {
  const query = {
    limit: `${limit ?? 0}`,
    skip: `${offset ?? 0}`,
  }
  return await genericRequest({ url: `${scopeWorkflowRoute}/`, method: "GET", query: query })
}

/**
 * Update a scope workflow.
 * 
 * @param workflow to update
 * 
 * @returns updated workflow
 */
export const updateScopeWorkflow = async (workflow: ScopeWorkflow) => {
  const body = JSON.stringify(workflow)
  return await genericRequest({ url: `${scopeWorkflowRoute}/${workflow.id}`, method: "PUT", body: body })
}

/**
 * Deletes a workflow scope.
 * 
 * @param scopeWorkflowId of scope workflow to delete.
 * 
 * @returns null if successful
 */
export const deleteScopeWorkflow = async (scopeWorkflowId: number): Promise<ScopeWorkflow | Error> => {
  return await genericRequest({ url: `${scopeWorkflowRoute}/${scopeWorkflowId}`, method: "DELETE" })
}
